import React, {useEffect, useState} from 'react';
import {sendReOrder} from "../orders/services";
import {GetHistory, GetStatuses, SendContact} from "./services";
import {formatDateTime, formatNumber} from "../helpers/formatHelper";
import {useFormik} from "formik";
import Yup from "../components/Yup";
import validMessage from "../helpers/ValidMessage";
import {createNewAddress} from "../checkout/services";
import {InputField, TextareaField} from "../components/formikField";

function MainView() {
    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            phone: '',
            content: '',
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required(validMessage.required).min(1,validMessage.min(1)).max(255,validMessage.max(255)),
            phone: Yup.string().required(validMessage.required).min(10,validMessage.min(10)).max(15,validMessage.max(15)).matches(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/, {message: validMessage.phone}),
            email: Yup.string().email(validMessage.email).required(validMessage.required).min(6,validMessage.min(6)).max(255,validMessage.max(255)),
            content: Yup.string().required(validMessage.required).min(1,validMessage.min(1)).max(255,validMessage.max(255)),
        }),
        onSubmit: async (values, {resetForm}) => {
            showLoading();
            SendContact(values,function (response) {
                hideLoading();
                if (response.statusCode === 200){
                    toastr.success("Gửi liên hệ thành công")
                    resetForm();
                }else{
                    toastr.error("Gửi liên hệ thất bại. "+response.message)
                }
            });
        },
    });
    
    
    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="form-group">
                <InputField id="name" name="name" placeholder="Họ tên" formik={formik}/>
            </div>
            <div className="form-group">
                <InputField id="email" name="email" placeholder="Nhập Email" formik={formik}/>
            </div>
            <div className="form-group">
                <InputField id="phone" name="phone" placeholder="Nhập số điện thoại" formik={formik}/>
            </div>
            <div className="form-group">
                <TextareaField rows={3} id="content" name="content" placeholder="Nhập nội dung" formik={formik} />
            </div>
            <button className="btn btn-red-heavy" type="submit">
                Gửi yêu cầu
            </button>
        </form>);
}

export default MainView;